const localStorageUtils = {
  get(key: string) {
    return localStorage.getItem(key) || '';
  },
  getAccessToken() {
    const res: string | null = localStorage.getItem(localStorageKey);
    if (res != null) {
      const result = JSON.parse(res);
      return result.token;
    }

    return null;
  },

  getUser() {
    const res: string | null = localStorage.getItem(localStorageKey);
    if (res != null) {
      const result = JSON.parse(res);
      return result;
    }
    return null;
  },
  getOrganisationId() {
    const res = this.getUser();
    if (res != null) {
      return res.details.organisationId;
    }
    return 'electrifuel';
  },
  getUserId() {
    const res = this.getUser();
    if (res != null) {
      return res.details.id;
    }
    return null;
  },
  removeUser() {
    localStorage.removeItem(localStorageKey);
  },
};
export default localStorageUtils;

export const localStorageKey = 'user';
